import { memo } from "react";
import PropTypes from "prop-types";

import StarringYouPresenter from "presenters/StarringYouPresenter";
import StarringYou from "components/StarringYouCards/components/StarringYou";
import StraightUp from "components/StraightUpCards/components/StraightUp";
import withAlgoliaTracking from "components/withAlgoliaTracking";

const StarringYouWithAlgolia = withAlgoliaTracking(StarringYou);
const StraightUpWithAlgolia = withAlgoliaTracking(StraightUp);

const MasonryItem = ({ card, onClick, hasModulePosition }) => {
  switch (true) {
    case StarringYouPresenter.isStarringYouClip(card):
      return <StarringYouWithAlgolia isClip item={card} onClick={onClick} hasModulePosition={hasModulePosition} />;
    case StarringYouPresenter.isStarringYou(card):
    case StarringYouPresenter.isStarringYouVertical(card):
    case StarringYouPresenter.isInvite(card):
    case StarringYouPresenter.isStarringYouAI(card):
      return <StarringYouWithAlgolia item={card} onClick={onClick} hasModulePosition={hasModulePosition} />;
    case StarringYouPresenter.isStraightUp(card):
      return (
        <StraightUpWithAlgolia item={card} isMasonryGrid onClick={onClick} hasModulePosition={hasModulePosition} />
      );
    default:
      return null;
  }
};

MasonryItem.propTypes = {
  card: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
    attributes: PropTypes.shape({}),
  }),
  onClick: PropTypes.func,
  hasModulePosition: PropTypes.bool,
};

export default memo(MasonryItem, (prevCard, newCard) => prevCard.card.id === newCard.card.id);
